import { media } from '~theme/breakpoints';
export const container = {
  backgroundColor: 'background',
  position: 'relative',
  maxWidth: 960,
  py: 5,
  px: 4,
  variant: 'styles.Container',
  [media.tablet]: {
    py: 4,
    px: 4,
    pt: 5
  }
};

if (typeof container !== 'undefined' && container && container === Object(container) && Object.isExtensible(container) && !container.hasOwnProperty('__filemeta')) {
  Object.defineProperty(container, '__filemeta', {
    configurable: true,
    value: {
      name: "container",
      filename: "../../node_modules/gatsby-theme-docz/src/components/MainContainer/styles.js"
    }
  });
}